module.exports = __webpack_public_path__ + "img/中国人民解放军联勤保障部队第九二〇医院.eb164a18.png";